module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.modules.length > 0) ? _c('div', {
    attrs: {
      "id": "dash_modules"
    }
  }, [_c('div', {
    staticClass: "module_container"
  }, [_c('div', {
    staticClass: "module_shadow"
  }, [_c('div', {
    staticClass: "module_header row no_wrap align_center justify_between"
  }, [_c('div', {
    staticClass: "span_auto"
  }, [_c('h2', [_vm._v(_vm._s(_vm.intro_module.fields.module_title))])])]), _vm._v(" "), _c('div', {
    staticClass: "module_copy row"
  }, [_c('div', {
    staticClass: "span_6_xs"
  }, [_c('p', {
    staticClass: "module_body_header"
  }, [_vm._v("Introduction")]), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.markdown(_vm.intro_module.fields.module_introduction))
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "span_6_xs"
  }, [_c('p', {
    staticClass: "module_body_header"
  }, [_vm._v("Learning Objectives")]), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.markdown(_vm.intro_module.fields.learning_objectives))
    }
  })])])]), _vm._v(" "), (_vm.intro_module.fields.related_materials) ? _c('div', {
    staticClass: "materials_container",
    class: {
      open: _vm.collapsed.intro_module
    },
    attrs: {
      "data-module": 'intro_module'
    }
  }, [_c('div', {
    staticClass: "materials_header row align_center justify_between",
    on: {
      "click": function($event) {
        _vm.collapse_toggle('intro_module')
      }
    }
  }, [_vm._m(0, false, false), _vm._v(" "), (!_vm.collapsed.intro_module) ? _c('div', {
    staticClass: "span_auto"
  }, [_vm._m(1, false, false)]) : _c('div', {
    staticClass: "span_auto"
  }, [_vm._m(2, false, false)])]), _vm._v(" "), _c('div', {
    staticClass: "materials_list",
    attrs: {
      "data-module": 'intro_module'
    }
  }, _vm._l((_vm.intro_module.fields.related_materials), function(item) {
    return _c('div', {
      staticClass: "download_row row justify_between"
    }, [_c('div', {
      staticClass: "span_auto"
    }, [_c('p', {
      staticClass: "download_title"
    }, [_c('i', {
      staticClass: "fa fa-file",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(_vm._s(item.fields.file.fileName))])]), _vm._v(" "), _c('div', {
      staticClass: "span_auto"
    }, [_c('a', {
      staticClass: "download_link",
      attrs: {
        "href": item.fields.file.url,
        "download": ""
      }
    }, [_vm._v("Download"), _c('i', {
      staticClass: "fa fa-download",
      attrs: {
        "aria-hidden": "true"
      }
    })])])])
  }))]) : _vm._e()]), _vm._v(" "), _vm._l((_vm.modules), function(module) {
    return _c('div', {
      staticClass: "module_container",
      attrs: {
        "id": 'module_' + module.module_number
      }
    }, [_c('div', {
      staticClass: "module_shadow"
    }, [_c('div', {
      staticClass: "module_header row no_wrap align_center justify_between"
    }, [_c('div', {
      staticClass: "span_10_xs"
    }, [_c('h2', [_vm._v(_vm._s(module.module_title))])]), _vm._v(" "), _c('div', {
      staticClass: "span_auto"
    }, [(module.active) ? _c('a', {
      staticClass: "bttn dash_bttn",
      attrs: {
        "target": "_blank",
        "href": '/module-' + module.module_number
      }
    }, [_vm._v("Launch Animation")]) : _c('span', {
      staticClass: "paragraph",
      style: ({
        color: 'white'
      })
    }, [_vm._v("Coming Soon")])])]), _vm._v(" "), _c('div', {
      staticClass: "module_copy row"
    }, [_c('div', {
      staticClass: "span_6_xs"
    }, [_c('p', {
      staticClass: "module_body_header"
    }, [_vm._v("Introduction")]), _vm._v(" "), _c('div', {
      domProps: {
        "innerHTML": _vm._s(_vm.markdown(module.module_introduction))
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "span_6_xs"
    }, [_c('p', {
      staticClass: "module_body_header"
    }, [_vm._v("Learning Objectives")]), _vm._v(" "), _c('div', {
      domProps: {
        "innerHTML": _vm._s(_vm.markdown(module.learning_objectives))
      }
    })])])]), _vm._v(" "), (module.related_materials) ? _c('div', {
      staticClass: "materials_container",
      class: {
        open: _vm.collapsed['module_' + module.module_number]
      },
      attrs: {
        "data-module": module.module_number
      }
    }, [_c('div', {
      staticClass: "materials_header row align_center justify_between",
      on: {
        "click": function($event) {
          _vm.collapse_toggle(module.module_number)
        }
      }
    }, [_vm._m(3, true, false), _vm._v(" "), (!_vm.collapsed['module_' + module.module_number]) ? _c('div', {
      staticClass: "span_auto"
    }, [_vm._m(4, true, false)]) : _c('div', {
      staticClass: "span_auto"
    }, [_vm._m(5, true, false)])]), _vm._v(" "), _c('div', {
      staticClass: "materials_list",
      attrs: {
        "data-module": module.module_number
      }
    }, _vm._l((module.related_materials), function(item) {
      return _c('div', {
        staticClass: "download_row row justify_between"
      }, [_c('div', {
        staticClass: "span_auto"
      }, [_c('p', {
        staticClass: "download_title"
      }, [_c('i', {
        staticClass: "fa fa-file",
        attrs: {
          "aria-hidden": "true"
        }
      }), _vm._v(_vm._s(item.fields.file.fileName))])]), _vm._v(" "), _c('div', {
        staticClass: "span_auto"
      }, [_c('a', {
        staticClass: "download_link",
        attrs: {
          "href": item.fields.file.url,
          "download": ""
        }
      }, [_vm._v("Download"), _c('i', {
        staticClass: "fa fa-download",
        attrs: {
          "aria-hidden": "true"
        }
      })])])])
    }))]) : _vm._e()])
  })], 2) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "span_auto"
  }, [_c('p', [_vm._v("EDUCATOR MATERIALS & PRINTABLES")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "collapse_link"
  }, [_vm._v("Open "), _c('i', {
    staticClass: "fa fa-caret-down",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "collapse_link"
  }, [_vm._v("Close "), _c('i', {
    staticClass: "fa fa-caret-up",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "span_auto"
  }, [_c('p', [_vm._v("EDUCATOR MATERIALS & PRINTABLES")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "collapse_link"
  }, [_vm._v("Open "), _c('i', {
    staticClass: "fa fa-caret-down",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "collapse_link"
  }, [_vm._v("Close "), _c('i', {
    staticClass: "fa fa-caret-up",
    attrs: {
      "aria-hidden": "true"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-24ee1625","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/dash_modules/dash_modules.vue
// module id = 628
// module chunks = 1